// extracted by css-extract-rspack-plugin
export default {"cls1":"SignupBanner-cls1_zW7","cls2":"SignupBanner-cls2_hCz SignupBanner-cls1_zW7"};